<template>
  <el-dialog title="缴费详情" :visible.sync="dialogVisible" width="1000px" class="pay-detail-list">
    <el-tabs value="base" v-loading="loading">
      <el-tab-pane label="收费信息" name="base">
        <table class="native-table">
          <tr>
            <th>收费项目</th>
            <th>原价（元）</th>
            <th>折后价格（元）</th>
            <th v-if="isRefund">补费金额（元）</th>
          </tr>
          <tr>
            <td>学费</td>
            <td>{{fee_detail.origin_class_fee?fee_detail.origin_class_fee:'-'}}</td>
            <td>{{ fee_detail.class_fee }}</td>
            <td v-if="isRefund">{{ def.class_fee || 0 }}</td>
          </tr>
          <tr>
            <td>材料费</td>
            <!-- <td>{{def.original_class_fee?def.original_class_fee.original_material_fee:'-'}}</td> -->
            <td>{{ fee_detail.material_fee }}</td>
            <td>{{ fee_detail.material_fee }}</td>
            <td v-if="isRefund">{{ def.material_fee }}</td>
          </tr>
          <tr>
            <td>保险费</td>
            <!-- <td>{{def.original_class_fee?def.original_class_fee.original_insurance:'-'}}</td> -->
            <td>{{ fee_detail.insurance }}</td>
            <td>{{ fee_detail.insurance }}</td>
            <td v-if="isRefund">{{ def.insurance || 0}}</td>
          </tr>
          <tr>
            <td>伙食费</td>
            <!-- <td>{{def.original_class_fee?def.original_class_fee.original_food_expenses:'-'}}</td> -->
            <td>{{ fee_detail.food_expenses }}</td>
            <td>{{ fee_detail.food_expenses }}</td>
            <td v-if="isRefund">{{ def.food_expenses || 0}}</td>
          </tr>
<!--          <tr>
            <td>陪读费</td>
            &lt;!&ndash; <td>{{def.original_class_fee?def.original_class_fee.original_accompanying_fee:'-'}}</td> &ndash;&gt;
            <td>{{ fee_detail.accompanying_fee }}</td>
            <td>{{ fee_detail.accompanying_fee }}</td>
            <td v-if="isRefund">{{ def.accompanying_fee || 0}}</td>
          </tr>-->
<!--          <tr>
            <td>托管费</td>
            &lt;!&ndash; <td>{{def.original_class_fee?def.original_class_fee.original_hosting_fee:'-'}}</td> &ndash;&gt;
            <td>{{ fee_detail.hosting_fee }}</td>
            <td>{{ fee_detail.hosting_fee }}</td>
            <td v-if="isRefund">{{ def.hosting_fee || 0}}</td>
          </tr>-->
          <tr v-if='defData.refund_type === 2'>
            <td>食宿交通门票等</td>
            <!--           <td>{{def.original_class_fee?def.original_class_fee.accommodation_traffic_ticket:'-'}}</td>-->
            <td>{{ fee_detail.accommodation_traffic_ticket }}</td>
            <td>{{ fee_detail.accommodation_traffic_ticket }}</td>
            <td v-if="isRefund">{{ def.accommodation_traffic_ticket || 0}}</td>
          </tr>
        </table>

        <!-- <p>应收金额：{{ totalFee }}元</p> -->
        <p class="result">
          <span class="title">折扣详情：</span>
          <span class="label">
            ({{ fee_detail.origin_class_fee }}
            <span class="mini">（原价）</span>
            <span v-if="fee_detail.shift_class_number">
              - {{ fee_detail.shift_class_number }}
              <span class="mini">（错过课程数）</span>
              * {{ fee_detail.origin_single_class_price || def.class_fee / def.courses_count }}
              <span class="mini">（单节课价）</span>
            </span>
            ) * {{ !fee_detail.discount_rate && fee_detail.discount_rate !== 0 ? 1 : fee_detail.discount_rate }}
            <span class="mini">（折扣率）</span>
            + 其他费用 （{{ otherFee }} 元） =
            <strong>{{ fee_detail.total_fee || totalFee }}（元）</strong>
          </span>
        </p>
        <p>折扣金额：{{ fee_detail.discount_reduction ? `${fee_detail.discount_reduction}元` : '一' }}</p>
        <p>
          <strong>实收金额：{{ def.real_fee ? `${def.real_fee}元` : '无' }}</strong>
        </p>
        <!-- 单独补费 -->
        <!-- <el-button
          v-if="isShow(1) && hasPermission('supply_apply')"
          @click="openSupply('addSupplyFee')"
          type="primary"
          class="m-b-10"
          >补费申请</el-button
        > -->
        <!-- 订单退费 -->
        <!-- <el-button
          v-if="
            isShow(3) && fee_detail.refund_info && fee_detail.refund_info.can_refund && hasPermission('refund_apply')
          "
          @click="openSupply('applyRefund')"
          type="danger"
          class="m-b-10"
          >退缴费</el-button
        > -->
        <!-- <el-button
          v-if="isShow(2) && isRefundAll && hasPermission('refund_apply')"
          @click="refundApplyAll"
          type="danger"
          class="m-b-10"
          >退剩余补费</el-button
        > -->
        <!-- 退费or补费渠道 -->
        <!-- <el-button v-if="isShow(4)" @click="refundApplyStatus('payByPos')">刷卡缴费</el-button> -->
        <!-- <el-button v-if="isShow(5)" type="primary" @click="refundApplyStatus('payByBash')">现金缴费</el-button> -->
        <!-- 补费拒绝 （退费拒绝在财务页面） -->
        <!-- <el-button v-if="isShow(6)" type="danger" @click="refundApplyStatus('supplyFeeReject')">拒绝补费</el-button> -->
        <!-- <el-dialog
          :title="method === 'addSupplyFee' ? '补费申请' : '退费申请'"
          append-to-body
          :visible.sync="dialogVisibleRefund"
          width="800px"
          class="refund-detail"
        >
          <refund-apply
            v-if="dialogVisibleRefund"
            :sign_up_id="sign_up_id"
            :keep_reserved="keep_reserved"
            :method="method"
            ref="refund"
            :defData="refundDefData"
          ></refund-apply>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisibleRefund = false">取 消</el-button>
            <el-button type="primary" @click="refundApply" :loading="loadingRefund">确 定</el-button>
          </span>
        </el-dialog> -->
      </el-tab-pane>
      <el-tab-pane label="学员信息" name="student">
        <ul class="inf-list">
          <li>
            <span>学员姓名</span>
            <i>{{ def.contact_name }}</i>
          </li>
          <li>
            <span>性别</span>
            <i>{{ defData.gender_label }}</i>
          </li>
          <li>
            <span>出生日期</span>
            <i>{{ defData.birthday }}</i>
          </li>
          <li>
            <span>身份证号</span>
            <i>{{ defData.id_card_no }}</i>
          </li>
          <li>
            <span>家长姓名</span>
            <i>{{ defData.real_name }}</i>
          </li>
          <li>
            <span>家长手机</span>
            <i>{{ defData.phone }}</i>
          </li>
        </ul>
      </el-tab-pane>
      <el-tab-pane label="班级信息" name="classes">
        <ul class="inf-list">
          <li>
            <span>学年</span>
            <i>{{ defData.year }}</i>
          </li>
          <li>
            <span>学期</span>
            <i>{{ defData.term_label }}</i>
          </li>
          <li>
            <span>班级名称</span>
            <i>{{ defData.name }}</i>
          </li>
          <li>
            <span>部门</span>
            <i>{{ defData.fee_level.org_full_name }}</i>
          </li>
          <li>
            <span>项目</span>
            <i>{{ defData.fee_level.specialized_subject_full_name }}</i>
          </li>
          <li>
            <span>级别</span>
            <i>{{ defData.fee_level.name }}</i>
          </li>
          <li>
            <span>负责教师</span>
            <i>{{ defData.teacher.map(item => item.real_name).join('，') }}</i>
          </li>
          <li>
            <span>是否摇号</span>
            <i>{{ defData.is_rocking_number_label }}</i>
          </li>
          <li>
            <span>是否面试</span>
            <i>{{ defData.is_interview_label }}</i>
          </li>
          <li>
            <span>年龄范围</span>
            <i>{{ defData.is_age_limit ? `${defData.min_age}岁 一 ${defData.max_age}岁` : '一' }}</i>
          </li>
          <li>
            <span>课表信息</span>
            <i>
              <el-button type="text" @click.native="showSc">查看</el-button>
            </i>
          </li>
        </ul>
      </el-tab-pane>
      <el-tab-pane label="补费信息" name="apply">
        <ly-table
          ref="lyTable"
          :searchFormData="searchFormData"
          :tableHeader="tableHeader"
          :getTableData="getTableData"
        >
          <template v-slot:action="row">
            <el-button
              type="text"
              v-if="
                !row.already_refund &&
                  buttons.length &&
                  row.supply_fee_status === 2 &&
                  row.supply_fee_remains > 0 &&
                  hasPermission('refund_apply')
              "
              size="mini"
              @click="openSupply('refundSupplyFee', row)"
              >退费
            </el-button>
          </template>
        </ly-table>
      </el-tab-pane>
      <el-tab-pane label="退费信息" name="refund">
        <ly-table
          ref="lyTableRefund"
          :searchFormData="searchFormData"
          :tableHeader="tableHeaderRefund"
          :getTableData="getTableDataRefund"
        ></ly-table>
      </el-tab-pane>
    </el-tabs>
    <el-dialog title="课程表" append-to-body :visible.sync="dialogVisibleSc" width="1400px">
      <class-schedule :class_mode="scTime.class_mode" :class_id="scTime.class_id" />
    </el-dialog>
  </el-dialog>
</template>
<script>
import { Dialog, Tabs, TabPane } from 'element-ui';
import { classApi, contact, finance } from '@/api';
import ClassSchedule from '@/components/ClassSchedule';
import RefundApply from '@/components/RefundApply';
import { applyTable, refundTable } from '@/utils/tableHeader';
import LyTable from '@/components/LyTable';
import perMixin from '@/utils/perMixin';

const Decimal = require('decimal.js/decimal.js');

export default {
  name: 'PayDetail',
  mixins: [perMixin],
  components: {
    ElDialog: Dialog,
    ElTabs: Tabs,
    ElTabPane: TabPane,
    ClassSchedule,
    RefundApply,
    LyTable
  },
  props: {
    def: {
      type: Object,
      default: () => ({})
    },
    class_id: {
      type: Number,
      required: true
    },
    contact_id: {
      type: Number,
      required: true
    },
    sign_up_id: {
      type: Number,
      required: true
    },
    buttons: {
      type: Array,
      required: true,
      default: () => []
    },
    isRefund: {
      type: Boolean,
      default: () => false
    },
    keep_reserved: {
      type: String,
      required: true
    }
  },
  computed: {
    totalFee() {
      try {
        return Decimal.add(this.defData.class_fee, this.otherFee).toNumber();
      } catch (e) {
        return 0;
      }
    },
    otherFee() {
      try {
        return Decimal.add(this.fee_detail.material_fee || 0, this.fee_detail.insurance || 0)
          .add(this.fee_detail.food_expenses || 0)
          .add(this.fee_detail.accompanying_fee || 0)
          .add(this.fee_detail.hosting_fee || 0)
          .add(this.fee_detail.accommodation_traffic_ticket || 0)
          .toNumber();
      } catch (e) {
        return 0;
      }
    },
    isShow() {
      return index => this.buttons.includes(index);
    },
    isRefundAll() {
      return this.fee_detail.refund_info && this.fee_detail.refund_info.supply_can_refund;
    },
    searchFormData() {
      return {
        sign_up_id: this.sign_up_id
      };
    }
  },
  data() {
    return {
      form: {
        insurance: '',
        class_fee: '',
        material_fee: '',
        food_expenses: '',
        accompanying_fee: '',
        hosting_fee: ''
      },
      dialogVisible: false,
      defData: {
        fee_level: {},
        teacher: []
      },
      dialogVisibleSc: false,
      scTime: {},
      dialogVisibleRefund: false,
      method: '',
      refundDefData: {}, // 退费信息（订单退费为订单信息defData，补费退费则为补费信息fee_detail）
      fee_detail: {},
      loading: false,
      tableHeader: applyTable,
      getTableData: finance.supplyFee,
      getTableDataRefund: finance.refundRecord,
      tableHeaderRefund: refundTable,
      loadingRefund: false
    };
  },
  methods: {
    init() {
      this.initClass();
      setTimeout(() => {
        this.$refs.lyTable.setData();
        this.$refs.lyTableRefund.setData();
      }, 0);
    },
    open() {
      this.dialogVisible = !this.dialogVisible;
      if (this.dialogVisible) {
        setTimeout(() => {
          this.initContact();
          this.init();
        }, 0);
      }
    },
    initClass() {
      this.loading = true;
      classApi
        .controlClass({
          id: this.class_id
        })
        .then(res => {
          if (res && res.data) {
            this.defData = {
              ...this.defData,
              ...res.data.class_info
            };
          }
        });
      finance
        .getRefundFee({
          sign_up_id: this.sign_up_id,
          class_id: this.class_id
        })
        .then(res => {
          this.loading = false;
          if (res) this.fee_detail = res.data.refund_fee_detail || {};
        });
    },
    initContact() {
      contact
        .getStudentDetail({
          params: {
            contact_id: this.contact_id
          }
        })
        .then(res => {
          if (res && res.data) {
            const resData = res.data.contact_info;
            delete resData.name;
            this.defData = {
              ...this.defData,
              ...resData
            };
          }
        });
    },
    showSc() {
      this.dialogVisibleSc = true;
      this.scTime = {
        class_id: this.class_id,
        class_mode: this.defData.class_mode
      };
    },
    async refundApply() {
      this.loadingRefund = true;
      const isSuccess = await this.$refs.refund.refundApply();
      this.loadingRefund = false;
      if (isSuccess) {
        this.dialogVisibleRefund = false;
        this.dialogVisible = false;
        this.$emit('success');
      }
    },
    async openSupply(method, row) {
      if (method === 'applyRefund' && this.$refs.lyTableRefund.nativeTableConfig.data.length) {
        try {
          await this.$confirm('是否二次申请退费？', '提示', {
            type: 'warning'
          });
        } catch (error) {
          return;
        }
      }
      if (method === 'refundSupplyFee') {
        const res = await finance.getSupplyFeeRefundDetail({
          params: {
            supply_fee_id: row.id,
            class_id: this.class_id
          }
        });
        if (!res) return;
        this.refundDefData = { ...res.data.supply_fee_refund_detail, id: row.id, class_id: this.def.class_id };
      } else {
        this.refundDefData = this.fee_detail;
      }
      this.dialogVisibleRefund = true;
      this.method = method;
    },
    async refundApplyStatus(method) {
      const res = await finance[method]({
        record_id: this.def.id
      });
      if (res) {
        this.$message.success(res.msg || '操作成功！');
        this.$emit('success');
        this.dialogVisible = false;
        return true;
      }
      return false;
    },
    refundApplyAll() {
      if (!this.fee_detail.refund_info) {
        this.$message.error('数据异常！');
        return;
      }
      this.$confirm(
        `剩余补费金额 ${this.fee_detail.refund_info.supply_fee_refund_remains_total} 元 ,是否申请退费？`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          finance
            .applyRefundSupplyFee({
              sign_up_id: this.sign_up_id,
              params: {
                refund_phase: this.fee_detail.refund_info.is_over_class
              }
            })
            .then(res => {
              if (res) {
                this.$message.success(res.msg || '申请成功');
              }
            });
        })
        .catch(() => {});
    }
  }
};
</script>
<style lang="less">
.pay-detail-list {
  .inf-list {
    list-style: none;

    li {
      float: left;
      overflow: hidden;
      margin: 10px;

      > span {
        font-weight: 600;
        display: inline-block;
        width: 100px;
        margin-right: 10px;
      }

      > i {
        font-style: normal;
        display: inline-block;
        min-width: 200px;
      }
    }
  }

  p {
    font-size: 16px;
  }

  .result {
    margin-top: 20px;

    .mini {
      font-size: 12px;
      color: #999;
    }

    strong {
      color: @danger;
    }
  }
}
</style>
